<template lang="pug">
.cp-callai-team
  .title 我们的团队
  photoWall
</template>
<script>
import photoWall from './photo-wall'

export default {
  components: {
    photoWall
  },
  props: {},
  data () {
    return {
    }
  },
  computed: {},
  methods: {}
}
</script>
<style lang="stylus">
.cp-callai-team
  margin-bottom 190px
</style>
